import React, { useEffect, useState } from 'react';
import TabBar from './components/TabBar';
import FileTree from './components/FileTree';
import CodeEditor from './components/CodeEditor';
import Preview from './components/Preview';
import Console from './components/Console';
import Toolbar from './components/Toolbar';
import WelcomeModal from './components/WelcomeModal';
import StatusBar from './components/StatusBar';
import { KeyboardShortcuts } from './components/KeyboardShortcuts';
import { useEditorStore } from './store/editorStore';
import { useAutoSave } from './hooks/useAutoSave';
import { getProjectFromUrl } from './utils/share';

const App: React.FC = () => {
  const { loadProject } = useEditorStore();
  const [showWelcome, setShowWelcome] = useState(() => {
    return localStorage.getItem('hide-welcome') !== 'true';
  });

  useAutoSave();

  // 从URL加载项目
  useEffect(() => {
    const projectFromUrl = getProjectFromUrl();
    if (projectFromUrl) {
      loadProject(projectFromUrl);
    }
  }, []);

  const handleCloseWelcome = () => {
    setShowWelcome(false);
    localStorage.setItem('hide-welcome', 'true');
  };

  return (
    <div className="h-screen flex flex-col bg-editor-bg text-white">
      <KeyboardShortcuts />
      <Toolbar />

      <div className="flex-1 flex overflow-hidden">
        {/* 左侧文件树 */}
        <div className="w-64 flex-shrink-0">
          <FileTree />
        </div>

        {/* 中间编辑区 */}
        <div className="flex-1 flex flex-col">
          <TabBar />
          <div className="flex-1">
            <CodeEditor />
          </div>
          <Console />
          <StatusBar />
        </div>

        {/* 右侧预览区 */}
        <div className="w-1/2 min-w-[400px] border-l border-editor-border flex flex-col">
          <div className="h-8 flex items-center px-3 bg-editor-panel border-b border-editor-border text-sm text-gray-400">
            实时预览
          </div>
          <div className="flex-1">
            <Preview />
          </div>
        </div>
      </div>

      {showWelcome && <WelcomeModal onClose={handleCloseWelcome} />}
    </div>
  );
};

export default App;
